export const routeCreate = {
    activityCreate: 'activityCreate',
    categoryCreate: 'categoryCreate',
    claimActionCreate: 'claimActionCreate',
    creditTypeCreate: 'creditTypeCreate',
    claimCreate: 'claimCreate',
    contactCreate: 'contactCreate',
    contactTypeCreate: 'contactTypeCreate',
    domainCreate: 'domainCreate',
    domainUserCreate: 'domainUserCreate',
    functionCreate: 'functionCreate',
    messageCreate: 'messageCreate',
    noticeCreate: 'noticeCreate',
    observationTypeCreate: 'observationTypeCreate',
    taskTypeCreate: 'taskTypeCreate',
    projectCreate: 'projectCreate',
    projectMemberCreate: 'projectMemberCreate',
    pageComponentCreate: 'pageComponentCreate',
    pageCreate: 'pageCreate',
    roleCreate: 'roleCreate',
    taskCreate: 'taskCreate',
    themeCreate: 'themeCreate',
    userCreate: 'userCreate',
} as const;

export type TRouteCreate = (typeof routeCreate)[keyof typeof routeCreate];
